import { render, staticRenderFns } from "./MenuEdit.vue?vue&type=template&id=0d245408&scoped=true"
import script from "./MenuEdit.vue?vue&type=script&lang=js"
export * from "./MenuEdit.vue?vue&type=script&lang=js"
import style0 from "./MenuEdit.vue?vue&type=style&index=0&id=0d245408&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d245408",
  null
  
)

export default component.exports